export enum UAApps {
  StorageByUA = 'storage_by_unifyapps',
  CommentsByUnifyApps = 'comments_by_unifyapps',
  Callables = 'callables',
  AuthByUA = 'auth_by_unifyapps',
  CodeByUA = 'code_by_unifyapps',
  CustomHttpEndpoint = 'custom_http_endpoint',
  PlatformByUA = 'platform_by_unifyapps',
  StandardEntities = 'standard_entities',
  UtilityByUA = 'utility_by_unifyapps',
  CalendarByUA = 'calendar_by_unifyapps',
  MCPByUA = 'mcp_by_unifyapps',
  Loop = 'loop',
  AnalyticsByUA = 'analytics_by_unifyapps',
}

export enum UAAppResources {
  CallablesCallAutomation = 'callables_call_automation',
  CallablesReturnResponseToApi = 'callables_return_response_to_api',
  CodeByUAGroovy = 'code_by_unifyapps_groovy',
  CodeByUAJavaScript = 'code_by_unifyapps_javascript',
  CustomHttpEndpointExecute = 'custom_http_endpoint_execute',
  EDIToolsByUAGenerateEDI = 'edi_tools_by_unifyapps_generate_edi',
  MCPByUAInvokeTool = 'mcp_by_unifyapps_invoke_tool',
  StandardEntitiesCreateOrUpdateUserPreferences = 'standard_entities_create_or_update_user_preferences',
  StandardEntitiesFetchUserPreferences = 'standard_entities_fetch_user_preferences',
  StandardEntitiesGetConnections = 'standard_entities_get_connections',
  UtilityByUADownloadFileAsString = 'utility_by_unifyapps_download_file_as_string',
  StorageByUACountRecords = 'storage_by_unifyapps_count_records',
  UtilityByUACreateUnifyappsPathForFile = 'utility_by_unifyapps_create_unifyapps_path_for_file',
}
